import React, { createContext, useContext, useState } from "react";

const DarkModeContext = createContext();

export const DarkModeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem("darkMode");
    if (saved !== null) return saved === "true";
    return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
  });

  const colors = {
    optionBg: darkMode ? "#252A3A" : "#f5f5f5",
    optionBorder: darkMode ? "#2C3045" : "#ddd",
    textPrimary: darkMode ? "#fff" : "#000",
    textSecondary: darkMode ? "#b0b0b0" : "#666",
    inputBg: darkMode ? "#1a1a2e" : "#fff",
    bgPaper: darkMode ? "#1B1F2E" : "#fff",
    border: darkMode ? "#2C3045" : "#ECECEC",
    textTertiary: darkMode ? "#8892A4" : "#BDBDBD",
    bgPrimary: darkMode ? "#141824" : "#F6F6F6",
    bgSecondary: darkMode ? "#1F2433" : "#F6F6F6",
    bgHeader: darkMode ? "#242938" : "#EEEEEE",
    accent: "#0040FF",
    hover: darkMode ? "#252A3A" : "#f6f6f6",
    borderLight: darkMode ? "#2C3045" : "#CACEE3",
    tableHeader: darkMode ? "#242938" : "#EEEEEE",
    accentBg: darkMode ? "#1A3A3C" : "#E8F5F5",
    gridLine: darkMode ? "#2C3045" : "#e0e0e0",
    dottedLine: darkMode ? "#4A5568" : "#bdbdbd",
  };

  const toggleDarkMode = () => {
    setDarkMode((prev) => {
      const next = !prev;
      localStorage.setItem("darkMode", String(next));
      return next;
    });
  };

  return (
    <DarkModeContext.Provider value={{ darkMode, toggleDarkMode, colors }}>
      {children}
    </DarkModeContext.Provider>
  );
};

export const useDarkMode = () => useContext(DarkModeContext);

export default DarkModeContext;
